import { AxiosResponse } from "axios";
import http from "@/common/utils/http-common-utils";
import ApiRouterConstants from "../../constants/api.router.constants";
import {
  ApiClinicDailyRoutineIndexRequest,
  ApiClinicDailyRoutineRequest,
  ApiClinicDailyRoutineResonponse,
  IClinicBusinessDaySetting,
} from "@/clinic/typings";
import { useAxios, EasyUseAxiosReturn } from "@vueuse/integrations/useAxios";
import { AnyFn } from "@vueuse/core";

const ClinicBusinessDaySettingService = {
  getSetting: async (
    params: ApiClinicDailyRoutineIndexRequest,
    onSuccess: AnyFn,
    onError: AnyFn
  ): Promise<
    EasyUseAxiosReturn<AxiosResponse<IClinicBusinessDaySetting>, AxiosResponse, IClinicBusinessDaySetting>
  > => {
    const { execute } = useAxios<AxiosResponse<IClinicBusinessDaySetting>, AxiosResponse, IClinicBusinessDaySetting>(
      ApiRouterConstants.API_CLINIC_ROUTINE,
      {
        method: "GET",
        params,
      },
      http,
      {
        immediate: false,
        onSuccess,
        onError,
      }
    );
    return await execute();
  },
  updateClinicRoutineDaily: async (
    payload: ApiClinicDailyRoutineRequest,
    clinicId: number,
    onSuccess: () => void,
    onError: (error: any) => void
  ): Promise<
    EasyUseAxiosReturn<AxiosResponse<ApiClinicDailyRoutineResonponse>, AxiosResponse, ApiClinicDailyRoutineResonponse>
  > => {
    const { execute } = useAxios<
      AxiosResponse<ApiClinicDailyRoutineResonponse>,
      AxiosResponse,
      ApiClinicDailyRoutineResonponse
    >(
      ApiRouterConstants.API_CLINIC_ROUTINE,
      {
        method: "PATCH",
      },
      http,
      {
        immediate: false,
        onSuccess: () => {
          onSuccess();
        },
        onError: (error: any) => {
          onError(error.response?.data?.errors);
        },
      }
    );
    return await execute({ data: payload, params: { clinic_id: clinicId } });
  },
};

export default ClinicBusinessDaySettingService;
